import { toLocalizedRiotUrl } from 'tradera/utils/language';
import { toLocalizedUrl } from 'tradera/utils/url';
import { getHistory } from 'tradera/utils/history';

const goToStart = function () {
    getHistory().push(toLocalizedRiotUrl('/selling/'));
};

const goToPublished = function (itemId) {
    getHistory().push(toLocalizedRiotUrl('/selling/published/' + itemId));
};

const goToVIP = function (itemId) {
    window.location.href = toLocalizedUrl('/item/' + itemId);
};

const setDraftUrlWithoutReload = function (draftId) {
    window.history.replaceState(
        {},
        document.title,
        toLocalizedRiotUrl('/selling/draft/' + draftId)
    );
};

export default {
    goToStart,
    goToPublished,
    goToVIP,
    setDraftUrlWithoutReload
};
